const guiColors = {
    'motion-primary': '#795548',
    'motion-primary-transparent': '#795548e6',
    'motion-tertiary': '#5d4037',

    'looks-secondary': '#795548',
    'looks-transparent': '#79554859',
    'looks-light-transparent': '#79554826',
    'looks-secondary-dark': 'hsla(15, 25%, 40%, 1)',

    'extensions-primary': 'hsla(15, 25%, 45%, 1)',
    'extensions-tertiary': 'hsla(15, 25%, 30%, 1)',
    'extensions-transparent': 'hsla(15, 25%, 45%, 0.35)',
    'extensions-light': 'hsla(15, 25%, 85%, 1)',

    'drop-highlight': '#a1887f'
};

const blockColors = {
    checkboxActiveBackground: '#795548',
    checkboxActiveBorder: '#5d4037'
};

export {
    guiColors,
    blockColors
};